import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// The version trait supplies history fields; the API declares no relationships.
const TasProgramInstanceVersionSchema = withDefaults({
  type: 'tas-program-instance-version',
  traits: ['version'],
  fields: [],
});

export default TasProgramInstanceVersionSchema;
